import React from "react";
import { useTranslation } from "react-i18next";

import arrow_right from "./../../assets/images/icons/arrow_right.svg";
import defaultBanner from "./../../assets/images/default_image.svg";

import "./../CardClub/CardClub.scss";
import { ReactSVG } from "react-svg";
import FallbackImage from "../FallbackImage";
import { getTechniqueMenuName } from "../../utils/functions";

function CardClub({
  data,
  isButton = true,
  handleClick,
  technical = false,
  useTechniqueMenuI18n = false,
}) {
  const { t } = useTranslation();
  const displayName =
    useTechniqueMenuI18n && data?.id
      ? getTechniqueMenuName(data, t)
      : data.name;
  return (
    <div className="card_club">
      <div className="card_club__image" onClick={() => handleClick(data.id)}>
        <FallbackImage
          variant="fill"
          paths={[data?.image, data?.bgr_image]}
          fallback={defaultBanner}
          alt={displayName || ""}
        />
      </div>
      <div
        className={`card_club__title ${
          technical ? `card_club__title--technical-detail` : ``
        }`}
        onClick={() => handleClick(data.id)}
      >
        {displayName}
      </div>
      <div
        className="card_club__button"
        style={{ display: isButton ? "flex" : "none" }}
        onClick={() => handleClick(data.id)}
      >
        {t("club-list.button")}
        <ReactSVG src={arrow_right} className="arrow-right" />
      </div>
    </div>
  );
}

export default CardClub;
